import { DateRange } from '@heda/core-util';
import { CodeName } from '@heda/core-util';
import { QueryParams } from '@heda/core-util';

export class MessageLog {
  public id: string;
  public messageId: string;
  public date: DateRange;
  public service: Service;
  public direction: string;
  public queueId: string;
  public participant: Participant;
  public request: any;
  public response: any;
  public status: string;
  public references: Array<LogReference>;
}

export class Service extends CodeName {
  public description: string;
  public contentType: string;
}

export class Participant extends CodeName {
  public url: string;
  public name: string;
}

export class LogReference {
  public resource: string;
  public resourceId: string;
}

export class LogSearchParams extends QueryParams {
  public messageId?: string;
  public dateTo?: Date;
  public dateFrom?: Date;
  public service?: string;
  public direction?: string;
  public participant?: string;
  public status?: string;
  public content?: string;
  public reference?: string;
}
